import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CasesSection from './components/CasesSection';
import PricingSection from './components/PricingSection';
import ContactSection from './components/ContactSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Flidge",
      "description": "Your partner for premium game localization",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "mainEntity": {
        "@type": "Organization",
        "name": "Flidge",
        "description": "Premium game localization services",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com",
        "logo": "https://static.readdy.ai/image/14090482ad00f674843640af3b243289/fb810d140e0b4ddfef604daebcce38fc.png",
        "sameAs": []
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <header>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Flidge</h1>
      </header>
      <Navigation />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CasesSection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
